"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemType = void 0;
var _ItemType = require("./ItemType.styles");
var _jsxRuntime = require("react/jsx-runtime");
const ItemType = props => {
  const {
    title
  } = props;
  const styles = (0, _ItemType.useStyles)(props);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-Item__type'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-Item__type-content'],
      children: title
    })
  });
};
exports.ItemType = ItemType;